import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Box } from "@mui/material";
import { ModalButton } from "../../pages/Mint/styles";
import { MintPageModalGroupProps } from "./types";
import { mintPageModalGroupStyles } from "./styles";
import { APP_BACKGROUND_COLOR, FONT_FAMILY } from "../../theme";

export const MintPageModalGroup: React.FC<MintPageModalGroupProps> = ({
  mintResponse,
  setMintResponse,
  handleGoToMyNFTS,
  isWalletLoading,
  connectedWallet,
}) => {
  return (
    <>
      <Modal
        isOpen={mintResponse !== undefined}
        centered
        contentClassName={"no-border"}
        toggle={() => setMintResponse(undefined)}
        backdrop={true}
        keyboard={false}
        style={{ fontFamily: FONT_FAMILY }}
      >
        <ModalHeader style={{ backgroundColor: APP_BACKGROUND_COLOR }}>
          Minting underway...
        </ModalHeader>
        <ModalBody style={mintPageModalGroupStyles.modalBody}>
          Data upload succeeded. Please check your NFT page to see minting
          status. Time to mint will vary depending on current gas fees.
          <Box sx={{ alignSelf: "center" }}>
            <ModalButton
              sx={{ marginRight: 2 }}
              type="submit"
              size="small"
              variant="contained"
              disableFocusRipple
              onClick={handleGoToMyNFTS}
              key={1}
            >
              My NFTS
            </ModalButton>
            <ModalButton
              type="submit"
              size="small"
              variant="contained"
              disableFocusRipple
              onClick={() => setMintResponse(undefined)}
              key={2}
            >
              Dismiss
            </ModalButton>
          </Box>
        </ModalBody>
      </Modal>
      {!isWalletLoading && (
        <Modal
          isOpen={!connectedWallet}
          centered
          contentClassName={"no-border"}
          backdrop={true}
          keyboard={false}
        >
          <ModalHeader>No connected wallet</ModalHeader>
          <ModalBody>
            This operation requires connected wallet, please connect your
            account!
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
